module.exports = __webpack_public_path__ + "static/img/cinemaBottom3.7737ca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cinemaBottom3.png
// module id = cUUa
// module chunks = 2